import React, { useEffect, useState } from "react";
import {
  Box,
  Container,
  Typography,
  Link,
  Stack,
  IconButton,
  Divider,
  Grid,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

import LinkedInIcon from "@mui/icons-material/LinkedIn";
import TwitterIcon from "@mui/icons-material/Twitter";
import GitHubIcon from "@mui/icons-material/GitHub";
import YouTubeIcon from "@mui/icons-material/YouTube";
import InstagramIcon from "@mui/icons-material/Instagram";
import LanguageIcon from "@mui/icons-material/Language";
import White_Logo from "../assets/Logo/company_logo_white.svg";
import { useServices } from "../context/ServicesContext";
import { useNavigate, useLocation } from "react-router-dom";
import { scrollToSection } from "../utils/utils";
import FooterColumn from "../components/footer/FooterColumn";
import FooterServices from "../components/footer/FooterServices";
import FooterContact from "../components/footer/FooterContact";
import API from "../config/axios";
import { api_paths } from "../config/api.paths";
// const Footer = () => {
//     const theme = useTheme();
//     const { t } = useTranslation();
//     const { services } = useServices();
//     const navigate = useNavigate();
//     const location = useLocation();

//     const handleScroll = (id) => {
//         if (location.pathname !== "/") {
//             navigate("/", { state: { scrollTo: id } });
//         } else {
//             scrollToSection(id);
//         }
//     };

//     const socialIcons = [
//         { icon: <LinkedInIcon />, link: '#' },
//         { icon: <TwitterIcon />, link: '#' },
//         { icon: <GitHubIcon />, link: '#' },
//         { icon: <InstagramIcon />, link: '#' },
//     ];

//     const footerSections = t('layout.footer.sections', { returnObjects: true });

//     return (
//         <Box
//             component="footer"
//             sx={{
//                 backgroundColor: theme.palette.background.footer,
//                 color: theme.palette.custom.footerTitle,
//                 pt: 10,
//                 pb: 4,
//                 mt: 'auto',
//             }}
//         >
//             <Container maxWidth="xl">
//                 {/* ================= TOP SECTION ================= */}
//                 <Grid container spacing={6} sx={{ mb: 4 }}>
//                     {/* BRAND */}
//                     <Grid size={{ xs: 12, md: 4 }}>
//                         <Box
//                             sx={{
//                                 display: "flex",
//                                 flexDirection: "column",
//                                 alignItems: "flex-start",
//                                 gap: 3,
//                                 maxWidth: { xs: "100%", md: 350 },
//                             }}
//                         >
//                             <img src={White_Logo} alt="Logo" style={{ height: 40 }} />

//                             <Typography
//                                 variant="body2"
//                                 component="p"
//                                 sx={{
//                                     color: theme.palette.custom.footerText,
//                                     typography: "textSm",
//                                 }}
//                             >
//                                 {t("layout.footer.slogan")}
//                             </Typography>

//                             <Stack direction="row" spacing={1.5}>
//                                 {socialIcons.map((item, index) => (
//                                     <IconButton
//                                         key={index}
//                                         href={item.link}
//                                         sx={{
//                                             color: theme.palette.custom.footerIconColor,
//                                             backgroundColor: "rgba(255,255,255,0.05)",
//                                             borderRadius: 2,
//                                             width: 40,
//                                             height: 40,
//                                             transition: "0.3s",
//                                             "&:hover": {
//                                             backgroundColor: theme.palette.primary.main,
//                                             color: theme.palette.common.white,
//                                             transform: "translateY(-3px)",
//                                             },
//                                         }}
//                                     >
//                                         {item.icon}
//                                     </IconButton>
//                                 ))}
//                             </Stack>
//                         </Box>
//                     </Grid>

//                     {/* LINKS SECTION */}
//                     <Grid size={{ xs: 12, md: 8 }}>
//                         <Grid container spacing={4}>

//                             <Grid size={{ xs: 12, sm: 6, md: 4 }}>
//                                 <FooterColumn
//                                     title={footerSections.company.title}
//                                     links={footerSections.company.links}
//                                     handleScroll={handleScroll}
//                                     theme={theme}
//                                 />
//                             </Grid>

//                             <Grid size={{ xs: 12, sm: 6, md: 4 }}>
//                                 <FooterServices
//                                     title={footerSections.services.title}
//                                     services={services}
//                                     handleScroll={handleScroll}
//                                     theme={theme}
//                                 />
//                             </Grid>

//                             <Grid size={{ xs: 12, sm: 12, md: 4 }}>
//                                 <FooterContact
//                                     contactData={footerSections.contact_us}
//                                     theme={theme}
//                                 />
//                             </Grid>
//                         </Grid>
//                     </Grid>
//                 </Grid>

//                 <Divider sx={{ borderColor: theme.palette.custom.footerDivider, mb: 3 }} />

//                 {/* ================= BOTTOM BAR ================= */}
//                 <Box
//                     sx={{
//                         display: 'flex',
//                         flexDirection: { xs: 'column', sm: 'row' },
//                         justifyContent: 'space-between',
//                         alignItems: 'center',
//                         gap: 2,
//                     }}
//                 >
//                     <Typography variant="body2" color={theme.palette.custom.footerCopyright}>
//                         {t('layout.footer.copyright')}
//                     </Typography>

//                     <Stack direction="row" spacing={3}>
//                         {Object.values(t('layout.footer.legal_links', { returnObjects: true })).map(
//                             (text, index) => (
//                                 <Link
//                                     key={index}
//                                     href="#"
//                                     underline="none"
//                                     color={theme.palette.custom.footerCopyright}
//                                     fontSize="0.85rem"
//                                     sx={{ '&:hover': { color: theme.palette.custom.footerLinkHover } }}
//                                 >
//                                     {text}
//                                 </Link>
//                             )
//                         )}
//                     </Stack>
//                 </Box>
//             </Container>
//         </Box>
//     );
// };

const Footer = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const { services } = useServices();
  const navigate = useNavigate();
  const location = useLocation();
  const [footerCms, setFooterCms] = useState(null); // ← ADD THIS

  // ← ADD THIS
  useEffect(() => {
    const fetchFooterCms = async () => {
      try {
        const response = await API.get(api_paths.CMS.get, {
          params: { slug: "footer" },
        });
        const pages = response.data?.payload?.data?.cmsPages || [];
        const footerPage = pages.find((p) => p.slug === "footer");
        setFooterCms(footerPage.meta);
        console.log("Footer CMS data:", footerPage);
      } catch (error) {
        console.error("Error fetching footer CMS:", error);
      }
    };
    fetchFooterCms();
  }, []);

  const handleScroll = (id) => {
    if (location.pathname !== "/") {
      navigate("/", { state: { scrollTo: id } });
    } else {
      scrollToSection(id);
    }
  };

  const socialIcons = [
    { icon: <LinkedInIcon />, link: "https://www.linkedin.com/company/nexuslink-services" },
    { icon: <TwitterIcon />, link: "https://x.com/nexuslink_india?" },
    // { icon: <GitHubI con />, link: "#" },
    { icon: <YouTubeIcon />, link: "https://www.youtube.com/@nexuslinkservices3417" },
    { icon: <InstagramIcon />, link: "https://www.instagram.com/nexuslinkservices/" },
    { icon: <LanguageIcon />, link: "https://nexuslinkservices.com/" },
  ];

  const footerSections = t("layout.footer.sections", { returnObjects: true });

  return (
    <Box
      component="footer"
      sx={{
        backgroundColor: theme.palette.background.footer,
        color: theme.palette.custom.footerTitle,
        pt: 10,
        pb: 4,
        mt: "auto",
      }}
    >
      <Container maxWidth="xl">
        <Grid container spacing={6} sx={{ mb: 4 }}>
          {/* BRAND */}
          <Grid size={{ xs: 12, md: 4 }}>
            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
                gap: 3,
                maxWidth: { xs: "100%", md: 350 },
              }}
            >
              <img src={White_Logo} alt="Logo" style={{ height: 40 }} />

              {/* ← USE CMS description */}
              <Typography
                variant="body2"
                component="p"
                sx={{
                  color: theme.palette.custom.footerText,
                  typography: "textSm",
                }}
              >
                {footerCms?.description || t("layout.footer.slogan")}
              </Typography>

              <Stack direction="row" spacing={1.5}>
                {socialIcons.map((item, index) => (
                  <IconButton
                    key={index}
                    href={item.link}
                    sx={{
                      color: theme.palette.custom.footerIconColor,
                      backgroundColor: "rgba(255,255,255,0.05)",
                      borderRadius: 2,
                      width: 40,
                      height: 40,
                      transition: "0.3s",
                      "&:hover": {
                        backgroundColor: theme.palette.primary.main,
                        color: theme.palette.common.white,
                        transform: "translateY(-3px)",
                      },
                    }}
                  >
                    {item.icon}
                  </IconButton>
                ))}
              </Stack>
            </Box>
          </Grid>

          {/* LINKS SECTION */}
          <Grid size={{ xs: 12, md: 8 }}>
            <Grid container spacing={4}>
              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <FooterColumn
                  title={footerSections.company.title}
                  links={footerSections.company.links}
                  handleScroll={handleScroll}
                  theme={theme}
                />
              </Grid>

              <Grid size={{ xs: 12, sm: 6, md: 4 }}>
                <FooterServices
                  title={footerSections.services.title}
                  services={services}
                  handleScroll={handleScroll}
                  theme={theme}
                />
              </Grid>

              {/* ← PASS CMS data to FooterContact */}
              <Grid size={{ xs: 12, sm: 12, md: 4 }}>
                <FooterContact
                  contactData={{
                    ...footerSections.contact_us,
                    email: {
                      label: footerSections.contact_us?.email?.label,
                      value:
                        footerCms?.email ||
                        footerSections.contact_us?.email?.value,
                    },
                    phone: {
                      label: footerSections.contact_us?.phone?.label,
                      value:
                        footerCms?.contact ||
                        footerSections.contact_us?.phone?.value,
                    },
                    location: {
                      label: footerSections.contact_us?.location?.label,
                      value:
                        footerCms?.location ||
                        footerSections.contact_us?.location?.value,
                    },
                  }}
                  theme={theme}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>

        <Divider
          sx={{ borderColor: theme.palette.custom.footerDivider, mb: 3 }}
        />

        {/* BOTTOM BAR */}
        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            justifyContent: "space-between",
            alignItems: "center",
            gap: 2,
          }}
        >
          <Typography
            variant="body2"
            color={theme.palette.custom.footerCopyright}
          >
            {t("layout.footer.copyright")}
          </Typography>

          <Stack direction="row" spacing={3}>
            {Object.values(
              t("layout.footer.legal_links", { returnObjects: true }),
            ).map((text, index) => (
              <Link
                key={index}
                href="#"
                underline="none"
                color={theme.palette.custom.footerCopyright}
                fontSize="0.85rem"
                sx={{
                  "&:hover": { color: theme.palette.custom.footerLinkHover },
                }}
              >
                {text}
              </Link>
            ))}
          </Stack>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
